
import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { useLoadingStore } from '@/store/loading'
import { useReuseTabStore } from '@/store/reuse-tab'

const loadingStore = useLoadingStore()

@Component({})
export default class ReuseTab extends Vue {
  @Prop({
    type: Array,
    default() {
      return []
    },
  })
  private list!: any[]

  @Prop({
    type: String,
    default: '',
  })
  private pos!: string

  private clock: any = null
  private loading = false
  private percent = 0
  private loadingStore = useLoadingStore()
  private reuseTabStore = useReuseTabStore()

  @Emit('changePath') private to(event: any, route: any) {
    // empty-function
  }
  private close(event: any, route: any, close: boolean) {
    if (this.list.length === 1) {
      this.$message.error('只有一个标签页时无法关闭')
      return
    }
    this.checkRoute(route, () => {
      this.onCloseTab(event, route, close)
    })
  }
  private async checkRoute(route, cb) {
    const { confirmClose, keepAlive } = this.reuseTabStore.to.meta
    try {
      let check = this.$route.name === route.name ? confirmClose : confirmClose && keepAlive
      if (check) {
        this.confirmTabClose(() => {
          cb()
        })
      } else {
        cb()
      }
    } catch (error) {
      console.log(error)
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private confirmTabClose(onOk = (confirm) => {}, onCancel = (confirm) => {}) {
    this.$confirm({
      title: '内容正在编辑中，是否关闭此页面？',
      onOk: () => {
        onOk(true)
      },
      onCancel: () => {
        onCancel(false)
      },
    })
  }

  @Emit('closeTab')
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private onCloseTab(event: any, route: any, close: boolean) {}

  @Watch('loadingStore.status')
  private loadingChange() {
    if (this.loadingStore.status === 'start') {
      this.percent = 0
      this.loading = true
      this.clock = setInterval(() => {
        this.percent += 1
      }, 100)
    } else if (this.loadingStore.status === 'completed') {
      this.clock = setInterval(() => {
        const percent = this.percent + 10
        this.percent = percent > 100 ? 100 : percent
      }, 100)
    }
  }

  @Watch('percent')
  private percentChange() {
    if (this.percent > 35 && this.loadingStore.status !== 'completed') {
      if (this.clock) {
        clearInterval(this.clock)
        this.clock = null
      }

      setTimeout(() => {
        this.percent += 0.1
      }, 2000)
    } else if (this.percent === 100) {
      clearInterval(this.clock)
      this.$nextTick(() => {
        this.clock = null
        this.loading = false
      })
    }
  }
  private get hasConfirmTab() {
    if (this.$route.meta?.confirmClose) {
      return true
    }
    for (let item of this.list) {
      const { confirmClose } = item.meta
      if (confirmClose) {
        return true
      }
    }
    return false
  }
  private created() {
    window.addEventListener('beforeunload', this.beforeunloadHandler)
  }
  /**
   * 关闭/重载当前网页时弹出提示
   */
  private beforeunloadHandler(e) {
    if (this.hasConfirmTab) {
      e.preventDefault()
      if (e || window.event) {
        e.returnValue = ''
      }
    }
  }
}
